import "./ProfileCards.scss";
import { Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap is loaded if needed
import { ProfileCardProps } from "../../Types";
import { useEffect } from "react";

const LABEL_ABBREVIATIONS: Record<string, string> = {
  'Household Income': 'HH income',
  'Household Size': 'HH size',
  'Household Location': 'HH location',
  'Census division': 'Division',
  'Work arrangement': 'Work arr.',
  'Main mode of transportation': 'Main mode',
  'Time poverty status': 'Time poverty',
  'Trip making status': 'Trip making',
};

const VALUE_ABBREVIATIONS: Record<string, string> = {
  'Non-metropolitan': 'Non-metro',
  'Metropolitan': 'Metro',
  'Multi-site workers': 'Multi-site',
  'Workers with zero work': 'Zero work',
  'In-home only workers': 'In-home only',
  'Commuters only': 'Commuters',
  'One or more trips': 'Trip maker',
  'Full-time worker': 'Full-time',
  'Part-time worker': 'Part-time',
  'West North Central': 'W. North Central',
  'East North Central': 'E. North Central',
  'West South Central': 'W. South Central',
  'East South Central': 'E. South Central',
  'Graduate degree(s)': 'Graduate deg.',
  'Less than high school': '< High school',
  'Some college degree': 'Some college',
  'Bachelor\'s degree': 'Bachelor\'s',
};

export default function ProfileCards({
    profileList,
    removeProfile,
    title,
    segmentColors,
}: ProfileCardProps): JSX.Element {
    return (
        <>
            <div className="profile-container">
                {title && (
                    <div style={{
                        fontSize: '14px',
                        fontWeight: 600,
                        color: '#374151',
                        marginBottom: '4px',
                        paddingLeft: '2px'
                    }}>
                        {title}
                    </div>
                )}
                <div className="profilecards">
                    <Col md="auto" style={{ display: "flex", justifyContent: "center", paddingBottom: "1rem"}} >
                        <div className="all-button">All</div>
                    </Col>
                    {profileList.map((profile, index) => {
                        return (
                            <Col
                                md="auto"
                                style={{ display: "flex", justifyContent: "space-evenly" }}
                                key={index}
                            >
                                <div className="profiles" id="closeablecard" style={{ borderLeftColor: segmentColors[index + 1] }}>
                                    <span className="profile-title">
                                        Segment {index + 1}
                                    </span>
                                    <button
                                        data-dismiss="alert"
                                        data-target="#closeablecard"
                                        onClick={() => removeProfile(index)}
                                        className="btn-close profile-close-x"
                                    ></button>
                                    <div className="profile-rows">
                                        {Object.values(
                                            Object.values(profile)[0].reduce(
                                                (acc: Record<string, { groupName: string; labels: string[] }>, opt) => {
                                                    const key = opt.groupName || opt.label;
                                                    if (!acc[key]) acc[key] = { groupName: opt.groupName || '', labels: [] };
                                                    acc[key].labels.push(opt.label);
                                                    return acc;
                                                },
                                                {}
                                            )
                                        ).map(({ groupName, labels }) => {
                                            if (!groupName) return null;
                                            const displayLabel = LABEL_ABBREVIATIONS[groupName] ?? groupName;
                                            const displayValues = labels.map(v => VALUE_ABBREVIATIONS[v] ?? v).join(', ');
                                            return (
                                                <div key={groupName} className="profile-row">
                                                    <span className="profile-row__label" style={{ color: segmentColors[index + 1] }}>{displayLabel}:</span>
                                                    <span className="profile-row__values">{displayValues}</span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </Col>
                        );
                    })}
                </div>
            </div>
        </>
    );
}